var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.posts.length !== 0
        ? _c(
            "div",
            _vm._l(_vm.posts, function(post, i) {
              return _c(
                "div",
                {
                  key: "post-".concat(i)
                },
                [
                  _c(
                    "gg-card",
                    {
                      class: post.staff
                        ? "reply-admin reply-margin"
                        : "reply-margin"
                    },
                    [
                      _c(
                        "gg-card-title",
                        {
                          staticClass: "app-card-title pt-0 pb-1"
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "px-4"
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    sm: "6"
                                  }
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "mr-2 pt-4 pb-1 d-inline-block"
                                    },
                                    [
                                      _vm._v(" " + _vm._s(post.account) + " "),
                                      post.staff == 1
                                        ? _c(
                                            "v-chip",
                                            {
                                              staticClass: "admin-chip mb-1",
                                              attrs: {
                                                small: "",
                                                dark: "",
                                                color: "primary"
                                              }
                                            },
                                            [_vm._v(" Staff Member ")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-left text-sm-right",
                                  attrs: {
                                    cols: "12",
                                    sm: "6"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "body-2"
                                    },
                                    [_vm._v(" " + _vm._s(post.date) + " ")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        {
                          staticClass: "post-white-space pt-0"
                        },
                        [_vm._v(" " + _vm._s(post.text) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Replies ")]),
              _c("gg-card-text", [
                _c("p", [
                  _vm._v(
                    "Your Cancellation Request has not been updated yet. Our Cancellations Team will update you as soon as possible."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "You will receive an email notification once your request has been updated. If you would like to provide more information, you may respond via the reply box at the top-right."
                  )
                ]),
                _c("p", [_vm._v("Thank you for your patience.")])
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }